"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useXsrfToken = exports.usePageTitle = exports.useNewfrontLogoFavicon = exports.useNewfrontFavicon = void 0;
var react_use_1 = require("react-use");
/**
 * @deprecated Please use useNewfrontLogoFavicon instead
 * Render the Newfront favicon based on the environment
 * @param environment
 */
function useNewfrontFavicon(environment) {
    (0, react_use_1.useFavicon)(environment
        ? "https://legacy.newfront.com/static/favicon-" + environment + ".png"
        : "https://legacy.newfront.com/static/favicon-production.png");
}
exports.useNewfrontFavicon = useNewfrontFavicon;
// TODO(ACC-1335):Remove favicon from accounts app
function useNewfrontLogoFavicon() {
    (0, react_use_1.useFavicon)("https://dash.newfront-staging.com/favicon.png");
}
exports.useNewfrontLogoFavicon = useNewfrontLogoFavicon;
/**
 * @deprecated Please use next/head <Head> component instead
 */
function usePageTitle(title) {
    return (0, react_use_1.useTitle)(title ? title + " | Newfront Insurance" : 'Newfront Insurance');
}
exports.usePageTitle = usePageTitle;
/**
 * Load the current CSRF token for this session.
 */
function useXsrfToken() {
    var token = (0, react_use_1.useCookie)('XSRF-TOKEN')[0];
    return token;
}
exports.useXsrfToken = useXsrfToken;
